import React from "react";

const DAYS = [
  { value: "monday", label: "Mon" },
  { value: "tuesday", label: "Tue" },
  { value: "wednesday", label: "Wed" },
  { value: "thursday", label: "Thu" },
  { value: "friday", label: "Fri" },
  { value: "saturday", label: "Sat" },
  { value: "sunday", label: "Sun" },
];

const DaysToggle = ({ value, onChange }) => {
  const selected = new Set(value || []);

  const toggle = (day) => {
    const next = new Set(selected);
    if (next.has(day)) next.delete(day); else next.add(day);
    onChange(Array.from(next));
  };

  return (
    <div className="cls-days">
      {DAYS.map((d) => (
        <label key={d.value} className={selected.has(d.value) ? "on" : ""}>
          <input
            type="checkbox"
            checked={selected.has(d.value)}
            onChange={() => toggle(d.value)}
          />
          {d.label}
        </label>
      ))}
    </div>
  );
};

export default DaysToggle;
